function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1665",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.707115,225.73658 c -1.635828,-2.25142 -4.288718,-3.71651 -7.28486,-3.71651 -2.99579,0 -5.648325,1.46509 -7.284508,3.71651 l 1.974498,3.42018 5.31001,9.19763 5.310365,-9.19763 1.974495,-3.42018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1667",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.422255,238.35439 h -7.266868 c 2.615141,8.19643 7.266868,19.49062 7.266868,19.49062 0,0 4.652082,-11.29419 7.267223,-19.49062 h -7.267223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1669",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.869092,229.99003 c -2.748492,-0.43569 -5.66032,0.40428 -7.77875,2.52271 -2.11843,2.11843 -2.958394,5.03026 -2.523419,7.77945 l 3.814938,1.02165 10.258425,2.7492 -2.748844,-10.25843 -1.02235,-3.81458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1671",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 25.640286,244.06304 -5.138561,5.13856 c 7.645047,3.94687 18.92053,8.64341 18.92053,8.64341 0,0 -4.696531,-11.27549 -8.64376,-18.92053 l -5.138209,5.13856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1673",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 7.313834,250.5605 c -2.2517803,1.63547 -3.7165136,4.28836 -3.7165136,7.28451 0,2.99578 1.4647333,5.64867 3.7165136,7.2845 l 3.419828,-1.97449 9.197974,-5.31001 -9.197621,-5.31037 -3.420181,-1.97414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1675",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.931636,257.84501 v 7.26722 c 8.196439,-2.6155 19.490619,-7.26722 19.490619,-7.26722 0,0 -11.294533,-4.65209 -19.490619,-7.26687 v 7.26687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1677",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 11.566923,275.39782 c -0.435681,2.74884 0.404636,5.66067 2.523066,7.7791 2.118431,2.11843 5.030258,2.95875 7.779103,2.52306 l 1.021997,-3.81423 2.749197,-10.25878 -10.258777,2.74885 -3.814586,1.022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1679",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 25.640286,271.62697 5.138209,5.13856 c 3.947229,-7.64539 8.64376,-18.92052 8.64376,-18.92052 0,0 -11.276188,4.69653 -18.92053,8.6434 l 5.138561,5.13856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1681",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.137747,289.95343 c 1.635477,2.25213 4.288015,3.71651 7.284156,3.71651 2.995787,0 5.649029,-1.46473 7.284861,-3.71651 l -1.974499,-3.41948 -5.310362,-9.19833 -5.310364,9.19798 -1.973792,3.41983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1683",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.421903,277.33562 7.267575,2.7e-4 c -2.615496,-8.19679 -7.267223,-19.49097 -7.267223,-19.49097 0,0 -4.652433,11.29453 -7.267223,19.49062 h 7.266871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1685",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.975065,285.69998 c 2.748844,0.43604 5.660319,-0.40392 7.779102,-2.52271 2.118432,-2.11843 2.958748,-5.03061 2.523067,-7.77945 l -3.814233,-1.02165 -10.258777,-2.7492 2.748846,10.25914 1.021995,3.81387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1687",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.204224,271.62697 5.13856,-5.13856 c -7.645397,-3.94687 -18.920529,-8.6434 -18.920529,-8.6434 0,0 4.696532,11.27583 8.643057,18.92052 l 5.138912,-5.13856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1689",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 71.530676,265.12951 c 2.252133,-1.63547 3.716514,-4.28766 3.716514,-7.2845 0,-2.99579 -1.464733,-5.64868 -3.716514,-7.28451 l -3.419827,1.9745 -9.198327,5.31001 9.198327,5.31071 3.419827,1.97379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1691",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.912522,257.84501 v -7.26723 c -8.19644,2.6155 -19.490267,7.26723 -19.490267,7.26723 0,0 11.294182,4.65243 19.490267,7.26757 v -7.26757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1693",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.277234,240.29219 c 0.436033,-2.74919 -0.403929,-5.66031 -2.522712,-7.7791 -2.118432,-2.11843 -5.030613,-2.95875 -7.779457,-2.52306 l -1.021643,3.81458 -2.749198,10.25843 10.259131,-2.74885 3.813879,-1.022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1695",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.204224,244.06304 -5.138912,-5.13856 c -3.946525,7.64575 -8.643057,18.92053 -8.643057,18.92053 0,0 11.275484,-4.69654 18.920529,-8.64306 l -5.13856,-5.13891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1697",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.864947,225.39298 c -2.372783,-1.45415 -5.383742,-1.79247 -8.152342,-0.64629 -2.768247,1.14653 -4.657724,3.51543 -5.307894,6.22194 l 3.133019,2.40383 8.425744,6.46571 1.386065,-10.52971 0.515408,-3.91548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1699",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.963474,239.83817 -6.714066,2.78059 c 5.553074,6.5719 14.172847,15.22625 14.172847,15.22625 0,0 -0.024,-12.21494 -0.744715,-20.78779 l -6.714066,2.78095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1701",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.545528,238.82746 c -2.7061579,0.64947 -5.0750607,2.53965 -6.2215882,5.30754 -1.146175,2.76825 -0.8078611,5.77991 0.6462889,8.15305 l 3.9154803,-0.51541 10.529358,-1.38642 -6.465006,-8.42574 -2.404533,-3.13302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1703",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.415067,250.38622 -2.780595,6.71407 c 8.573206,0.72073 20.787783,0.74472 20.787783,0.74472 0,0 -8.654343,-8.62013 -15.226241,-14.1725 l -2.780947,6.71371"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1705",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 6.9702287,263.40231 c -1.4545028,2.37279 -1.7924639,5.3841 -0.6462889,8.15235 1.1465275,2.76789 3.5150776,4.65842 6.2215882,5.30789 l 2.403828,-3.13302 6.465711,-8.42574 -10.529358,-1.38642 -3.9154803,-0.51506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1707",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.415067,265.30379 2.780947,6.71406 c 6.571898,-5.55307 15.226241,-14.17284 15.226241,-14.17284 0,0 -12.215283,0.024 -20.787783,0.74506 l 2.780595,6.71372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1709",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.404711,284.72173 c 0.649111,2.70651 2.539295,5.07471 5.307542,6.22159 2.768247,1.14618 5.779911,0.80821 8.152342,-0.64629 l -0.515408,-3.91512 -1.385713,-10.53007 -8.426096,6.46571 -3.132667,2.40418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1711",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.963474,275.85184 6.714066,2.7813 c 0.720374,-8.57356 0.744715,-20.78813 0.744715,-20.78813 0,0 -8.620477,8.65469 -14.172847,15.22624 l 6.714066,2.78059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1713",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.979212,290.29703 c 2.373135,1.45486 5.384093,1.79282 8.152693,0.64629 2.767542,-1.14653 4.658077,-3.51508 5.307894,-6.22159 l -3.133019,-2.40347 -8.425743,-6.46642 -1.386772,10.53007 -0.515053,3.91512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1715",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.881037,275.85184 6.714066,-2.78024 c -5.553075,-6.57225 -14.172848,-15.22659 -14.172848,-15.22659 0,0 0.02363,12.21493 0.744715,20.78778 l 6.714067,-2.78095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1717",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 66.29863,276.86255 c 2.706862,-0.64911 5.07506,-2.53929 6.221587,-5.30754 1.146175,-2.76825 0.808215,-5.77991 -0.646287,-8.1527 l -3.914775,0.51541 -10.530416,1.38607 6.46571,8.42645 2.404181,3.13231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1719",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.428739,265.30379 2.781651,-6.71407 c -8.57391,-0.72037 -20.788135,-0.74471 -20.788135,-0.74471 0,0 8.653992,8.62047 15.225535,14.17284 l 2.780949,-6.71406"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1721",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 71.874282,252.28805 c 1.454502,-2.37314 1.792817,-5.38409 0.64629,-8.15269 -1.14653,-2.7679 -3.515432,-4.65808 -6.221942,-5.3079 l -2.404181,3.13302 -6.465359,8.42574 10.530065,1.38678 3.915127,0.51505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1723",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.42909,250.38622 -2.7813,-6.71371 c -6.571543,5.55308 -15.225535,14.1725 -15.225535,14.1725 0,0 12.214577,-0.0236 20.787784,-0.74437 l -2.780949,-6.71442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1725",
    style: {
      fill: "#16d0d8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.439799,230.96863 c -0.649465,-2.70686 -2.539294,-5.07506 -5.307542,-6.22159 -2.768245,-1.14653 -5.77991,-0.80821 -8.153045,0.64594 l 0.515408,3.91548 1.386417,10.52971 8.426095,-6.46571 3.132667,-2.40383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1727",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.881037,239.83817 -6.714422,-2.78059 c -0.72037,8.5732 -0.74436,20.78743 -0.74436,20.78743 0,0 8.620125,-8.654 14.172848,-15.22589 l -6.714066,-2.78095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1729",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.821395,238.45599 c -0.988131,-1.35961 -2.589742,-2.24438 -4.39914,-2.24438 -1.809398,0 -3.411008,0.88477 -4.398785,2.24438 l 1.192035,2.06551 3.20675,5.55378 3.20675,-5.55378 1.19239,-2.06551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1731",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.422255,246.07528 h -4.388202 c 1.578679,4.94947 4.388202,11.76973 4.388202,11.76973 0,0 2.809169,-6.82026 4.388557,-11.76973 h -4.388557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1733",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.822342,241.02456 c -1.659467,-0.26317 -3.417712,0.24377 -4.697237,1.5233 -1.279172,1.27917 -1.786466,3.03741 -1.523294,4.69758 l 2.303286,0.61737 6.194425,1.65981 -1.659819,-6.19477 -0.617361,-2.30329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1735",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.099522,249.52262 -3.10268,3.10304 c 4.616448,2.38301 11.425413,5.21935 11.425413,5.21935 0,0 -2.836333,-6.80897 -5.2197,-11.42542 l -3.103033,3.10303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1737",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.032883,253.44622 c -1.359252,0.98778 -2.244019,2.58939 -2.244019,4.39879 0,1.80904 0.884767,3.411 2.244019,4.39878 l 2.065514,-1.19239 5.554133,-3.20639 -5.55378,-3.2064 -2.065867,-1.19239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1739",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.65253,257.84501 v 4.38855 c 4.949473,-1.57974 11.769725,-4.38855 11.769725,-4.38855 0,0 -6.820252,-2.80917 -11.769725,-4.38821 v 4.38821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1741",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 22.601811,268.44457 c -0.263172,1.65982 0.24377,3.41806 1.523294,4.69759 1.279173,1.27952 3.037417,1.78646 4.697237,1.52329 l 0.617008,-2.30329 1.660172,-6.19477 -6.194425,1.65982 -2.303286,0.61736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1743",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.099522,266.16739 3.103033,3.10303 c 2.383367,-4.6168 5.2197,-11.42541 5.2197,-11.42541 0,0 -6.809316,2.83633 -11.425413,5.21934 l 3.10268,3.10304"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1745",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.02347,277.23402 c 0.987425,1.35996 2.589035,2.24438 4.398433,2.24438 1.809396,0 3.411361,-0.88477 4.399137,-2.24438 l -1.192387,-2.06516 -3.20675,-5.55413 -3.20675,5.55413 -1.191683,2.06516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1747",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.421903,269.61473 4.388909,2.6e-4 c -1.57974,-4.94982 -4.388557,-11.77007 -4.388557,-11.77007 0,0 -2.809875,6.82025 -4.388556,11.76972 h 4.388204"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1749",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.021815,274.66545 c 1.659822,0.26317 3.418065,-0.24342 4.69759,-1.52329 1.279525,-1.27953 1.786467,-3.03777 1.523294,-4.69759 l -2.303285,-0.61701 -6.194777,-1.66017 1.659818,6.19513 0.61736,2.30293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1751",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.744637,266.16739 3.103033,-3.10304 c -4.616805,-2.38301 -11.425415,-5.21934 -11.425415,-5.21934 0,0 2.835982,6.80931 5.219348,11.42541 l 3.103034,-3.10303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1753",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.811274,262.24379 c 1.359958,-0.98778 2.244373,-2.58903 2.244373,-4.39878 0,-1.80905 -0.884767,-3.41101 -2.244373,-4.39879 l -2.06516,1.19239 -5.554134,3.2064 5.554134,3.20675 2.06516,1.19203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1755",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 51.19198,257.84501 v -4.38856 c -4.950177,1.57939 -11.769725,4.38856 -11.769725,4.38856 0,0 6.8199,2.80952 11.769725,4.3889 v -4.3889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1757",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.242699,247.24544 c 0.263173,-1.66017 -0.243417,-3.41806 -1.523294,-4.69758 -1.279525,-1.27918 -3.037768,-1.78647 -4.69759,-1.5233 l -0.61736,2.30329 -1.659818,6.19477 6.195128,-1.65981 2.302934,-0.61737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1759",
    style: {
      fill: "#5ca8ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.744637,249.52262 -3.103034,-3.10303 c -2.383366,4.61681 -5.219348,11.42542 -5.219348,11.42542 0,0 6.808965,-2.83634 11.425415,-5.21935 l -3.103033,-3.10304"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1761",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.066632,238.24855 c -1.432983,-0.87841 -3.251552,-1.08267 -4.923012,-0.39052 -1.671815,0.69285 -2.813051,2.12301 -3.20534,3.75708 l 1.891595,1.45203 5.088465,3.90384 0.83679,-6.35811 0.311502,-2.36432"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1763",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.91834,246.97098 -4.054475,1.67958 c 3.3528,3.9684 8.55839,9.19445 8.55839,9.19445 0,0 -0.01482,-7.37624 -0.449791,-12.55325 l -4.054124,1.67922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1765",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.192008,246.36103 c -1.633714,0.39229 -3.063875,1.53353 -3.75673,3.20534 -0.69215,1.67111 -0.487892,3.49003 0.390172,4.92301 l 2.364669,-0.3115 6.358114,-0.83714 -3.903486,-5.08812 -1.452739,-1.89159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1767",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.548233,253.34074 -1.679222,4.05447 c 5.177367,0.43533 12.553244,0.4498 12.553244,0.4498 0,0 -5.22605,-5.20524 -9.194448,-8.55839 l -1.679574,4.05412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1769",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.82545,261.20063 c -0.878064,1.43298 -1.082322,3.2519 -0.390172,4.92266 0.692855,1.67181 2.123016,2.8134 3.75673,3.20569 l 1.452034,-1.89159 3.904191,-5.08847 -6.358114,-0.83679 -2.364669,-0.3115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1771",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.548233,262.34892 1.679574,4.05448 c 3.968398,-3.35316 9.194448,-8.55839 9.194448,-8.55839 0,0 -7.376231,0.0148 -12.553244,0.44979 l 1.679222,4.05412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1773",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.93828,274.0749 c 0.392289,1.63407 1.533525,3.06423 3.20534,3.75708 1.671108,0.69215 3.490029,0.48789 4.923012,-0.39052 l -0.311502,-2.36432 -0.837141,-6.35811 -5.088114,3.90384 -1.891595,1.45203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1775",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.917989,268.71903 4.054475,1.67922 c 0.434623,-5.17737 0.449791,-12.55324 0.449791,-12.55324 0,0 -5.205941,5.2264 -8.55839,9.19444 l 4.054124,1.67958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1777",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.777878,277.44146 c 1.432984,0.87877 3.251552,1.08302 4.922661,0.39052 1.67146,-0.69285 2.813401,-2.12301 3.205691,-3.75708 l -1.891593,-1.45168 -5.088467,-3.90419 -0.837142,6.35811 -0.31115,2.36432"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1779",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.92617,268.71903 4.054475,-1.67958 c -3.353155,-3.96839 -8.55839,-9.19444 -8.55839,-9.19444 0,0 0.0141,7.37623 0.449792,12.55324 l 4.054123,-1.67922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1781",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.651797,269.32898 c 1.634418,-0.39229 3.064579,-1.53317 3.757083,-3.20534 0.691796,-1.67111 0.487892,-3.49003 -0.390525,-4.92301 l -2.363965,0.3115 -6.358466,0.83714 3.904191,5.08847 1.451682,1.89124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1783",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.295924,262.34927 1.679223,-4.05447 c -5.177015,-0.43498 -12.552892,-0.44979 -12.552892,-0.44979 0,0 5.225698,5.20559 9.194094,8.55839 l 1.679575,-4.05413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1785",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.018707,254.48938 c 0.878065,-1.43298 1.082675,-3.2512 0.390525,-4.92266 -0.692856,-1.67181 -2.123017,-2.8134 -3.757435,-3.20569 l -1.451682,1.89159 -3.903837,5.08847 6.358112,0.83714 2.364317,0.31115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1787",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.296278,253.34109 -1.679929,-4.05447 c -3.968396,3.3535 -9.194094,8.55839 -9.194094,8.55839 0,0 7.375877,-0.0145 12.552892,-0.44944 l -1.678869,-4.05448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1789",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.90623,241.61511 c -0.39229,-1.63407 -1.533525,-3.06423 -3.20534,-3.75673 -1.671108,-0.6925 -3.490028,-0.48824 -4.923012,0.39017 l 0.311502,2.36432 0.837142,6.35847 5.088115,-3.9042 1.891593,-1.45203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1791",
    style: {
      fill: "#366475",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.926522,246.97134 -4.054827,-1.67923 c -0.434975,5.17737 -0.44944,12.5529 -0.44944,12.5529 0,0 5.205235,-5.22605 8.55839,-9.1941 l -4.054123,-1.67957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1793",
    style: {
      fill: "#2a2d3f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.54517,257.84501 c 0,2.27682 -1.846088,4.12256 -4.122915,4.12256 -2.276827,0 -4.12256,-1.84574 -4.12256,-4.12256 0,-2.27719 1.845733,-4.12292 4.12256,-4.12292 2.276827,0 4.122915,1.84573 4.122915,4.12292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower4);
export default __webpack_public_path__ + "static/media/flower-4.5d17ce6e4ba1c4234cb3fbf9320cb6e0.svg";
export { ForwardRef as ReactComponent };